import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { faCogs } from "@fortawesome/free-solid-svg-icons";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";

import ResellerLogo from '../header/ResellerLogo';
import ResellerCSS from '../header/ResellerCSS';

class EmergencyHeader extends Component {
  render() {
    return (
      <header className="no-print">
        <ResellerLogo url="/fire-log" />

        <div className="top-header">
          <nav className="left-nav">
            <ul>
              <li><Link to={'/fire-log'}><FontAwesomeIcon icon={faHome} /> Firelog</Link></li>
            </ul>
          </nav>

          <nav className="right-nav">
            <ul>
              <li><Link to={'/settings'}><FontAwesomeIcon icon={faCogs} /> Settings</Link></li>
              <li><Link to={'/logout'}><FontAwesomeIcon icon={faSignOutAlt} /> Log Out</Link></li>
            </ul>
          </nav>
        </div>

        <div className="bottom-header">
          <div className="dr-header-text">
            Digital Reception
          </div>
        </div>

        <ResellerCSS />
      </header>
    )
  }
}

export default EmergencyHeader;
